export default __webpack_public_path__ + "static/header-marketing-5dbfe66046a01b5501d35ef899944d22.png";